const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

let isInitialized = false;

/**
 * Dynamically load gtag.js and initialize GA4.
 * Only call this AFTER the user has given cookie consent.
 */
export function initAnalytics() {
  if (isInitialized) {
    return;
  }

  if (!MEASUREMENT_ID) {
    if (import.meta.env.MODE !== 'production') {
      console.warn(
        '[Analytics] VITE_GA_MEASUREMENT_ID is not set. GA4 will not be initialized.'
      );
    }
    return;
  }

  // Load gtag.js script dynamically
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', MEASUREMENT_ID, {
    send_page_view: false, // We handle page views manually
  });

  isInitialized = true;
}

/**
 * Track a page view. No-op if GA4 is not initialized.
 * @param {string} path - The page path (e.g. '/pricing')
 */
export function trackPageView(path) {
  if (!isInitialized || !window.gtag) {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title,
  });
}

/**
 * Track a custom event. No-op if GA4 is not initialized.
 * @param {string} name - Event name (e.g. 'sign_up', 'button_click')
 * @param {Record<string, unknown>} [params] - Optional event parameters
 */
export function trackEvent(name, params = {}) {
  if (!isInitialized || !window.gtag) {
    return;
  }

  window.gtag('event', name, params);
}

/**
 * Check if analytics has been initialized.
 * @returns {boolean}
 */
export function isAnalyticsInitialized() {
  return isInitialized;
}
